<template>
  <div>
    <va-aside-layout :title="asideTitle">
      <base-material-card>
        <template v-slot:heading>
          <div class="display-2">
            {{ titleForm }}
          </div>
        </template>
        <robot-department-form
          :id="id"
          :item="item"
          @saved="onSaved"
        ></robot-department-form>
      </base-material-card>
    </va-aside-layout>
    <base-material-card :icon="icon" :title="title">
      <va-list
        ref="list"
        resource="robot_department"
        :filters="filters"
        disable-create-redirect
        @action="onAction"
        :include="includes"
      >
        <va-data-table
          disable-show
          :fields="fields"
          disable-create-redirect
          disable-edit-redirect
          @item-action="onAction"
        >
        </va-data-table>
      </va-list>
    </base-material-card>
  </div>
</template>

<script>
export default {
  props: ["icon", "title", "robot_id"],
  data() {
    return {
      includes: [{ api: `robotDepartment/${this.robot_id}` }],

      filters: [{ source: "department_id" }, { source: "robot_id" }],
      fields: [
        { source: "desc_department", label: "Departamento", sortable: true },
        { source: "name_robot", label: "Robo", sortable: true }
      ],
      asideTitle: null,
      titleForm: null,
      id: null,
      item: null,
      show: false
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onAction({ title, id, item }) {
      this.asideTitle = " ";
      this.titleForm = title;
      this.id = id;
      if (item == null) {
        var _item = {};
        for (let i = 0; i < this.fields.length; i++) {
          _item[this.fields[i].source] = null;
        }
        _item["robot_id"] = this.robot_id;
        this.item = _item;
      } else {
        this.item = item;
      }
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    }
  }
};
</script>
